var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-pulse shadow-sm rounded-md max-w-sm"},[_c('div',{staticClass:"w-full bg-gray-300 h-60 md:h-96"}),_c('div',{staticClass:"flex flex-col mt-1 space-y-1 h-8 justify-center"},[_c('div',{staticClass:"w-full bg-gray-300 h-4"}),_c('div',{staticClass:"w-full max-w-[6em] bg-gray-300 h-3"})])])
}]

export { render, staticRenderFns }